import React from 'react';
import {
  ArrowLeftRight, Navigation, Container, Layers, Shield, Package,
  FileText, MapPin, Ship, FileCheck,
  Globe, BadgeDollarSign, Eye, Clock
} from 'lucide-react';
import ServicePageTemplate from '../components/ServicePageTemplate';

const SeaFreight = () => {
  return (
    <ServicePageTemplate
      heroTitle="Sea Freight"
      heroImage="/img/sea-freight.jpg"
      slug="sea-freight"
      introText={[
        'Denver Logistics Private Limited, with its extensive global network, is well positioned to manage every aspect of your ocean freight requirements from origin to destination.',
        'We offer reliable and cost-effective sea freight solutions, including FCL, LCL, cargo consolidation, and multimodal transportation, ensuring safe, efficient, and timely delivery across major ports worldwide.',
      ]}
      services={[
        'Door-to-Door',
        'Port-to-Port',
        'FCL & LCL Services',
        'Cargo Consolidation',
        'Cargo Insurance',
        'Packing & Labelling',
        'Export / Import Documentation',
        'Cargo Tracking & Tracing',
        'Sea-Air Multimodal Shipment',
        'Customs Clearance',
      ]}
      serviceIcons={[
        ArrowLeftRight, Navigation, Container, Layers, Shield, Package,
        FileText, MapPin, Ship, FileCheck
      ]}
      benefits={[
        { title: 'Extensive Global Network', description: 'Strong partnerships with leading carriers and agents across major ports worldwide.' },
        { title: 'Cost-Effective Solutions', description: 'Competitive rates and optimized routing to reduce your logistics costs.' },
        { title: 'End-to-End Visibility', description: 'Real-time tracking and proactive updates across the entire shipping journey.' },
        { title: 'Safe & Timely Delivery', description: 'Committed to secure handling and on-time delivery of your valuable cargo.' },
      ]}
      benefitIcons={[Globe, BadgeDollarSign, Eye, Clock]}
      callout={{
        eyebrow: 'RELIABLE OCEAN FREIGHT SOLUTIONS.',
        sub: 'Our experts are here to help.',
        ctaLabel: 'TALK TO OUR SEA FREIGHT TEAM',
      }}
      faq={[
        { q: 'What is the difference between FCL and LCL?', a: 'FCL (Full Container Load) means your cargo fills an entire container. LCL (Less than Container Load) means your cargo shares container space with other shipments. FCL is more cost-effective for larger volumes, while LCL is ideal for smaller shipments.' },
        { q: 'How long does sea freight typically take?', a: 'Transit times depend on the trade lane. Major routes like India to Europe take 18-25 days, India to USA 25-35 days, and India to Southeast Asia 7-14 days. We provide estimated transit times for every booking.' },
        { q: 'Do you handle customs clearance for sea freight?', a: 'Yes. We provide end-to-end customs clearance services including documentation, HS code classification, duty assessment, and liaison with customs authorities at both origin and destination.' },
        { q: 'What types of cargo can be shipped by sea?', a: 'We handle general cargo, bulk commodities, project cargo, oversized equipment, temperature-controlled goods, and hazardous materials (with proper DGR compliance). Our team will advise on the best container type for your cargo.' },
      ]}
    />
  );
};

export default SeaFreight;
